import type {Collection} from 'services/series/types';
import {isCollectionSubType} from './isCollectionSubType';

export const isCollectionValue = (value: unknown): value is Collection =>
  typeof value === 'object' &&
  isCollectionSubType((value as Collection).collectionType);
